import { debounce } from "lodash";
import { makeObservable, observable, action, runInAction } from "mobx";
import { getProjects, getHashTags } from "../api";
import { getStorage } from "../utils/storage";
import { GlobalErrorType, IApiHeader } from "./appStoreTypes";
import {
  initialSearchState,
  initialHashTagState,
  ICurrentSearchState,
} from "./searchStoreTypes";

export default class SearchStore {
  constructor() {
    makeObservable(this, {
      searchState: observable,
      onInitSearchList: action,
      onUpdateSearchList: action,

      autoCompleteState: observable,
      onInitHashtagList: action,
      onGetHashTagList: action,

      searchErrorState: observable,
      onUpdateSearchError: action,
      currentSearchState: observable,
      onUpdateCurrentSearch: action,
    });
  }
  currentSearchState: ICurrentSearchState = {
    inputValue: "",
    searchValue: "",
  };
  onUpdateCurrentSearch = (state: ICurrentSearchState) => {
    const { inputValue, searchValue } = state;
    if (inputValue !== undefined) {
      this.currentSearchState = state;
    } else {
      this.currentSearchState = {
        searchValue,
        inputValue: "",
      };
    }
  };
  searchState = initialSearchState;
  onInitSearchList = () => {
    this.searchState = initialSearchState;
  };

  onUpdateSearchList = async (apiHeader: IApiHeader, targetTag?: string) => {
    const searchState = this.searchState;

    searchState.isLoadingList = true;
    const page = targetTag ? 1 : searchState.page;
    const tag = targetTag ? targetTag : searchState.tag;
    const type =
      getStorage("select_type") === "hashtag" ? "v1_search" : "v2_search";
    if (!tag) return;
    try {
      const { data, error } = await getProjects({
        ...apiHeader,
        tag,
        page,
        display: searchState.display,
        type,
      });

      if (error) {
        return this.onUpdateSearchError(GlobalErrorType.NET_WORK);
      }

      runInAction(() => {
        if (!data) {
          throw console.error("onUpdateSearchList is fail!");
        }

        if (page === 1) {
          searchState.list = data;
        } else {
          searchState.list = searchState.list.concat(data);
        }
        searchState.tag = tag;
        searchState.page = page + 1;
        this.autoCompleteState = initialHashTagState;
      });
    } catch {
      this.onUpdateSearchError(GlobalErrorType.UNKNOWN);
    } finally {
      runInAction(() => {
        searchState.isLoadingList = false;
      });
    }
  };

  autoCompleteState = initialHashTagState;
  onInitHashtagList = () => {
    this.autoCompleteState = initialHashTagState;
  };
  onGetHashTagList = debounce(
    async (
      apiHeader: IApiHeader,
      type: "hashtag" | "title",
      targetTag?: string
    ) => {
      let tag =
        type === "hashtag"
          ? targetTag?.replace(
              // eslint-disable-next-line
              /[` ~!@$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
              ""
            )
          : targetTag;
      // 연속된 # 시 에러 발생 ex)##
      if (type === "hashtag" && tag?.includes("##")) {
        tag = `#${tag.replace(/#/gi, "")}`;
      }

      // 검색 불가능한 문자만 있는 경우 반환
      if (!tag) return this.onInitHashtagList();

      const { page, display } = this.autoCompleteState;
      try {
        const { data, error } = await getHashTags({
          ...apiHeader,
          tag,
          page,
          display,
          type,
        });

        if (error) {
          return this.onUpdateSearchError(GlobalErrorType.NET_WORK);
        }

        runInAction(() => {
          if (!data || data.length === 0) {
            this.autoCompleteState.list = [];
            this.autoCompleteState.isEmpty = true;
            return;
          }
          this.autoCompleteState.type = type;
          if (type === "hashtag") {
            this.autoCompleteState.list = data;
            this.autoCompleteState.isEmpty = false;
          } else {
            this.autoCompleteState.list = data.hashTags;
            // this.autoCompleteState.list = this.autoCompleteState.list.concat(
            //   data.titles
            // );
            this.autoCompleteState.isEmpty = false;
          }
        });
      } catch {
        this.onUpdateSearchError(GlobalErrorType.UNKNOWN);
      }
    },
    300
  );

  searchErrorState = GlobalErrorType.NONE;
  onUpdateSearchError = (state: GlobalErrorType) => {
    this.searchErrorState = state;
    this.searchState.isLoadingList = false;
  };
}
